import {createAsyncThunk} from '@reduxjs/toolkit';

import {TABLE_REPORT_SLICE} from '../table-report-slice-constants';
import {TTableReportAddCommentToRowRequest, tableReportAttachmentsApi} from './table-report-row-attachments-api';

const {
    postAddCommentToRow,
} = tableReportAttachmentsApi;

export const attachCommentToRow = createAsyncThunk<
    any, TTableReportAddCommentToRowRequest
>(
    `${TABLE_REPORT_SLICE}/attachCommentToRow`,
    async (args, {rejectWithValue}) => {
        try {
            const addResultResponse = await postAddCommentToRow(args);
            return addResultResponse.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
